import React, { Component } from "react";
import Storage from "../../services/storage.service";
import Translations from "../../services/translation.service";
import HeaderNavigation from "./header-navigation.component";
import Settings from "../../services/settings.service";
import MenuDropdownCloseIcon from "../../assets/img/MenuDropdown.svg";
import MenuDropDownIcon from "../../assets/img/MenuDropDownClose.svg";
import ModernHamIcon from "../../assets/img/ModernHam.svg";
import logo from '../../assets/img/VM_logo.svg';
import User from "../../services/user.service";
import DownloadMenuButton from "./download-menu-button.component";
import DownloadlinkButton from "../../views/shared/download-link-button"
import checkModule from "./checkModule";
import StorefrontSubHeader from "./sub-storefront-header.component";
import CONSTANTS from "../../services/constants.service";
import ProgressPrompt from "./progressPrompt/progress-prompt-index";
import FirebaseAnalytics from "../../services/analytics.service";

class StorefrontHeader extends Component {
    state = {
        expanded: false,
        menu: false,
        menus: null,
        expanded_parent: null,
        sub: null,
        super_sub: null,
        join_now: true,
        active_sub_menu: null, 
        openModal: false,
        redirectUrl: "",
        internalRedirectUrl: "",
        eventId: ""
    };  

    subscriptions = [];
    componentWillUnmount() {
        if (this.subscriptions) {
            for (let subscription of this.subscriptions) {
                subscription.unsubscribe();
            }
        }
    }

    componentDidMount() {
        this.subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                this.forceUpdate();
            })
        );

        this.subscriptions.push(
            Storage.get_obsrv("flags").subscribe(data => {
                // Handle Quick Topup with Graph
                if (data?.choose_topup_category) {
                    this.setState({
                        active_sub_menu: CONSTANTS.QUICK_SERVICE.QUICKTOPUP,
                    })
                    return;
                }
                // Handle Bill Payment with Graph
                if (data?.choose_bill_payment) {
                    this.setState({
                        active_sub_menu: CONSTANTS.QUICK_SERVICE.PAYBILLS,
                    })
                    return;
                }
                // Handle Sim Deactivation with Graph
                if (data?.choose_sim_deactivation) {
                    this.setState({
                        active_sub_menu: CONSTANTS.QUICK_SERVICE.SIMDEACTIVATION,
                    })
                    return;
                }
                // Handle Onboarding with Graph
                this.setState({
                    active_sub_menu: CONSTANTS.QUICK_SERVICE.JOINNOW,
                })
            })
        );

        this.subscriptions.push(
            Storage.get_obsrv("active_static_route").subscribe(data => {
                // To Handle Protection Channel Flow
                let IsProtectionChannelRedirect = Storage.get('protection_channel_redirect', true);
                // To Handle Advertisement Flow
                let IsAdvertisementRedirect = Storage.get('advertisement_redirect', true);
                if (data) {
                    if(IsProtectionChannelRedirect && data === CONSTANTS.QUICK_SERVICE.PROTECTIONCHANNEL) {
                        this.setState({
                            active_sub_menu: CONSTANTS.QUICK_SERVICE.PROTECTIONCHANNEL,
                        })
                        return;
                    }
                    if(IsAdvertisementRedirect && data === CONSTANTS.QUICK_SERVICE.ADVERTISEMENT) {
                        this.setState({
                            active_sub_menu: CONSTANTS.QUICK_SERVICE.ADVERTISEMENT,
                        })
                        return;
                    }
                }
            })
        );

        this.subscriptions.push(
            Storage.get_obsrv("menus").subscribe(data => {
                this.setState({
                    menus: typeof data === 'string' ? JSON.parse(data) : data
                });
            })
        );
    }

    menuToggle = () => {
        this.setState({
            menu: !this.state.menu
        });
    }

    loadSimDeactivation = () => {
        User.clear();
        Storage.clear("session");
        localStorage.clear();
        Storage.set("is_web_category_selected", true, true);
        Storage.set("choose_sim_deactivation", true, true);
        this.setState({
            join_now: true
        })
        window.location.href = "/join/";
    }

    loadPayBills = () => {
        User.clear();
        Storage.clear("session");
        localStorage.clear();
        Storage.set("is_web_category_selected", true, true);
        Storage.set("choose_bill_payment", true, true);
        this.setState({
            join_now: true
        })
        window.location.href = "/join/";
    }

    loadTopup = () => {
        User.clear();
        Storage.clear("session");
        localStorage.clear();
        Storage.set("is_web_category_selected", true, true);
        Storage.set("choose_topup_category", true, true);
        this.setState({
            join_now: true
        })
        window.location.href = "/join/";
    }

    loadJoinNow = () => {
        User.clear();
        Storage.clear("session");
        localStorage.clear();
        this.setState({
            join_now: false
        })
        window.location.href = "/join/";
    }

    checkStorage = () => {
        Storage.get_obsrv("flags").subscribe(data => {
            if (data?.NumberSelected === false && data?.PlanSelected === false) {
                User.clearAll()
            }
        })
    }

    logFirebaseEventOnLogoClick = () => {
        const firebase_event_params = {
            event_screen: 'storefront',
            event_label: 'header',
            interaction_type: 'click',
            event_category: 'storefront',
            current_page: window.location.pathname,
        }
        FirebaseAnalytics.commonFunction(firebase_event_params);
    }

    // featureEnableQuickTopup = () => {
    //     return Helpers.checkEnableTopup("feature_enable_quick_topup");
    // }

    findSubcategories(parentId, lang) {
        if (!lang && !this.state.menus) return;
        if (this.state?.menus?.[lang]) {
            return this.state?.menus?.[lang]
                .filter((item) => item.parent === parentId)
                .map((item) => {
                    const subCategory = {
                        ID: item.ID.toString(),
                        url: item.url,
                        title: item.title,
                        event_property: item?.event_property || "",
                        parent: item.parent.toString(),
                    };
                    const subSubCategories = this.findSubcategories(item.ID, lang);
                    if (subSubCategories.length > 0) {
                        subCategory.subSubCategory = subSubCategories;
                    }
                    return subCategory;
                });
        }
        return;
    }

    handleSubCategoryClick(item) {
        // From Top Header
        if (item.ID === 91033) {
            localStorage.setItem("advertisement_redirect", true);
            localStorage.setItem("advertisement_redirect_url", Settings?.quick_links?.advertisement);
            localStorage.setItem("advertisement_step", true);
        }
        if (item.ID === 91032) {
            localStorage.setItem("protection_channel_redirect", true);
            localStorage.setItem("protection_channel_redirect_url", Settings?.quick_links?.protection_channel);
            localStorage.setItem("protection_channel_step", true);
        }
    }
    createRecreatedObject(lang) {
        if (!lang && !this.state.menus) return;
        if (this.state?.menus?.[lang]) {
            return this.state?.menus?.[lang]
                .filter((item) => item.parent === 0)
                .map((item) => {
                    const category = {
                        ID: item.ID.toString(),
                        url: item.url,
                        title: item.title,
                        event_property: item?.event_property || "",
                        parent: item.parent.toString(),
                    };
                    const subcategories = this.findSubcategories(item.ID, lang);
                    if (subcategories.length > 0) {
                        category.subcategory = subcategories;
                    }
                    return category;
                });
        }
        return;
    }

    createMyMenu(menuData) {
        if (!menuData) return null;
        return <>
            {menuData.map((item, index) => {
                return <li className={item.subcategory ? "storefront-parent-menu has-sub-menu" : "storefront-parent-menu"} key={index}>
                    {item.subcategory ? <span onClick={() => {
                        if (this.state.sub === item.ID) {
                            this.setState({
                                sub: null
                            });
                        } else {
                            this.setState({
                                sub: item.ID
                            });
                        }
                    }}
                        className={this.state.sub === item.ID ? "active-sub-menu" : "inactive-sub-menu"}
                    >{item.title} <img src={MenuDropdownCloseIcon} alt="" /></span> : <a onClick={this.handleLinkClick} href={item.url} className="custom-menu-a" data-event={item?.event_property}>{item.title}</a>}
                    {item.subcategory &&
                        <ul className={`storefront-sub-menu-container ${this.state.sub === item.ID ? "show-on-mob" : "hide-on-mob"}`}>
                            {item.subcategory.map((subItem, index) => {
                                return <li className={subItem.subSubCategory ? "storefront-sub-menu has-super-sub-menu" : "storefront-sub-menu"} key={`sub-${index}`}>
                                    {subItem.subSubCategory ? <span onClick={() => {
                                        if (this.state.super_sub === subItem.ID) {
                                            this.setState({
                                                super_sub: null
                                            });
                                        } else {
                                            this.setState({
                                                super_sub: subItem.ID
                                            });
                                        }
                                    }} className={this.state.super_sub === subItem.ID ? "active-super-sub-menu" : "inactive-super-sub-menu"}>{subItem.title} <img src={this.state.super_sub === subItem.ID ? MenuDropDownIcon : MenuDropdownCloseIcon} alt="" /></span> : <a onClick={this.handleLinkClick} className="custom-menu-b" href={subItem.url} data-id={subItem.ID} data-event={subItem?.event_property}>{subItem.title}</a>}
                                    {subItem.subSubCategory && this.state.super_sub === subItem.ID &&
                                        <ul className="storefront-super-sub-menu-container" data-id={subItem.ID} data-event={subItem?.event_property}>
                                            {subItem.subSubCategory.map((subSubItem, index) => {
                                                return <li key={`subSub-${index}`}>
                                                    {checkModule.isHeaderKsa ? <a onClick={() => this.handleSubCategoryClick(subItem)} className="custom-menu-c" href={subItem.url} data-event={subItem?.event_property}>{subItem.title}</a> : null}
                                                    {checkModule.isHeaderKw ? <a onClick={this.handleLinkClick} className="custom-menu-c" href={subSubItem.url} data-event={subItem?.event_property}>{subSubItem.title}</a> : null}
                                                </li>
                                            })}
                                        </ul>
                                    }
                                </li>
                            })}
                        </ul>
                    }
                </li>
            })}
        </>;
    }


    handleModal = (e) => {
        this.setState(prevState => ({
            openModal: !prevState.openModal
        }));
    };

    staticLanguageLink = (link, linkAR) => {
        if (Translations.activeLang === "en") {
          return link;
        }
        if (Translations.activeLang === "ar") {
          return linkAR;
        }
        return "#";
    };
    

    handleProtection = () => {
        localStorage.setItem("protection_channel_redirect", true);
        localStorage.setItem("protection_channel_redirect_url", Settings?.quick_links?.protection_channel);
        localStorage.setItem("protection_channel_step", true);
        // Add this line to set the active_static_route storage value
        Storage.set("active_static_route", CONSTANTS.QUICK_SERVICE.PROTECTIONCHANNEL, true);
       
        if (window.location.href.includes("protection-channel-survey")) {
           return;
        } 
        // Check if we're already on protection channel path using full href (more robust)
        if (window.location.href.includes("protection-channel")) {
            window.location.reload();
        } 
    } 

    handleYes = () => {
        if(this.state.internalRedirectUrl) {
        switch (this.state.internalRedirectUrl) {
            case "joinNow":
                this.loadJoinNow();
                break;
            case "billPayment":
                this.loadPayBills();
                break;
            case "protectionChannel":
                // handleProtection();
                // window.location.href = staticLanguageLink(Settings.footer?.protection_channel, Settings.footer?.protection_channel)
                break;
            case "simDeactivation":
                this.loadSimDeactivation();
                break;
            default:
                break;
        }
        } else {
            if(this.state.redirectUrl) {
                const firebase_event_params = {
                    button_name: this.state.eventId,
                    ...this.getFirebaseEventParamsAdditionalKeys()
                }
                FirebaseAnalytics.commonFunction(firebase_event_params);
            if(this.state.redirectUrl.includes("protection-channel")) {
                this.handleProtection();
                window.location.href = this.staticLanguageLink(Settings.footer?.protection_channel, Settings.footer?.protection_channel)
            } else {
                window.location.href = this.state.redirectUrl;
            }
        }
        }
        // setOpenModal((prev) => !prev);
        this.setState(prevState => ({
            openModal: !prevState.openModal
        }));
        // window.open(redirectUrl, '_blank'); // Open the internal route in a new tab
    }

    handleInternalClick = (type) => {
        this.setState(prevState => ({
            internalRedirectUrl: type,
            openModal: !prevState.openModal
        })); 
    }

    handleLinkClick = (event) => {
        const clickedId = event.currentTarget.getAttribute('data-id');
        const eventId = event.currentTarget.getAttribute('data-event');
        const planID = '90989';
        if (clickedId === planID) {
            // Handle the match case
            event.preventDefault(); // Prevent the default link behavior
            this.handleInternalClick("joinNow");
        } else {
            event.preventDefault(); // Prevent the default link behavior
            const url = event.currentTarget.getAttribute("href");
            this.setState(prevState => ({
                redirectUrl: url,
                openModal: !prevState.openModal,
                eventId: eventId
            }));
        }
    };

    getFirebaseEventParamsAdditionalKeys = () => {
        return {
            event_category: 'storefront',
            event_screen: 'storefront',
            interaction_type: 'click',
            event_label: 'header',
        }
    }

    commonRecordFirebaseEvent = ({ event_screen = "", event_label = "", interaction_type = "", ...properties }) => {
        const event_params = {
            event_category: "storefront",
            event_screen,
            event_label,
            interaction_type,
            ...properties
        }
        FirebaseAnalytics.commonFunction(event_params)
    }

    render() {
        let lang = Translations.getCurrentLanguage();
        let other = Translations.getTheOtherLanguage();
        let name = Translations.getLanguageNativeName(other);
        let language_switcher = (
            <li
                className="storefront-language"
            >
                <span
                    onClick={() => {
                        // Only toggle menu on mobile (≤979px)
                        if (window.innerWidth <= 979) {
                            this.menuToggle();
                        }
                        this.commonRecordFirebaseEvent({
                            event_screen: "language_selector",
                            event_label: "language_name",
                            interaction_type: "click",
                            language_selected: other
                        });
                        Translations.changeLanguage(other);
                    }}
                >
                    {name}
                </span>
            </li>
        );

        return (
            <>
                <div className="storefront-header-container">
                    <HeaderNavigation
                        menu={this.createMyMenu(this.createRecreatedObject(lang))}
                        lang={language_switcher}
                        activeLang={lang}
                        loadTopup={this.loadTopup}
                        join_now={this.state.join_now}
                        loadJoinNow={this.loadJoinNow}
                    />
                </div>
                <div className="storefront-header-mob-container">
                    <div className="storefront-header-mob">
                        <a onClick={() => { 
                            this.checkStorage()
                            this.logFirebaseEventOnLogoClick()
                        }}
                            href={Settings.get('site_link') + lang + "/"}
                            className="main-logo">
                            <img src={logo} alt="Virgin Mobile" />
                        </a>
                        {checkModule.isHeaderKw ? <DownloadlinkButton /> : null}
                        <img src={ModernHamIcon} alt="" onClick={this.menuToggle} />
                    </div>
                    {this.state.menu &&
                        <div className="storefront-header-mob-links">
                            <ul>
                                {this.createMyMenu(this.createRecreatedObject(lang))}
                                {checkModule.isHeaderKw ? <DownloadMenuButton /> : null}
                                {language_switcher}
                            </ul>
                            <StorefrontSubHeader 
                                loadJoinNow={this.loadJoinNow} 
                                loadTopup={this.loadTopup}
                                loadPayBills={this.loadPayBills}
                                loadSimDeactivation={this.loadSimDeactivation}
                                menuToggle={this.menuToggle} 
                                activeSubMenu={this.state.active_sub_menu} 
                                isMobile
                            />
                        </div>}
                </div>
                {!this.state.menu ? <StorefrontSubHeader 
                    loadJoinNow={this.loadJoinNow} 
                    loadTopup={this.loadTopup}
                    loadPayBills={this.loadPayBills}
                    loadSimDeactivation={this.loadSimDeactivation}
                    menuToggle={this.menuToggle}
                    activeSubMenu={this.state.active_sub_menu}
                /> : null}
                <ProgressPrompt handleModal={this.handleModal} openModal={this.state.openModal} handleYes={this.handleYes}/>
            </>
        );
    }
}

export default StorefrontHeader;